<template>
  <div class="hello">
      <h3>It looks like you've completed this quiz.</h3>
         <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              You got {{results.correct}} out of {{results.total}}  correct<p></p>
              <b-button block squared @click="getResults()" size="lg" variant="outline-dark" >Retake Quiz</b-button><p></p>
          </div>
         <div class="col-sm-4"></div>
         </div>
  </div>
</template>

<script>
export default {
  name: 'FinishedQuiz',
  props: {
    results: Object,
    // staticTitle: String
  },
    data () {
        return {
        }
    },
    methods: {
        getResults: function () {
            console.log('try to retake quize')
            this.$emit('retake')
        }
    },
    created () {
        // this.getTitle()
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
